var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebhook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_8230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H49V49H0V0Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.153125 0H0V0.153125H0.153125V0Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 32.1562H13.7812V33.6875H35.2188V32.1562ZM35.2188 33.6875H13.7812V35.2188H35.2188V33.6875ZM35.2188 35.2188H13.7812V36.75H35.2188V35.2188ZM35.2188 36.75H13.7812V38.2812H35.2188V36.75ZM16.8438 38.2812H13.7812V39.8125H16.8438V38.2812ZM35.2188 38.2812H18.375V39.8125H35.2188V38.2812ZM16.8438 39.8125H13.7812V41.3438H16.8438V39.8125ZM35.2188 39.8125H18.375V41.3438H35.2188V39.8125ZM16.8438 41.3438H13.7812V42.875H16.8438V41.3438ZM35.2188 41.3438H18.375V42.875H35.2188V41.3438ZM16.8438 42.875H13.7812V44.4062H16.8438V42.875ZM35.2188 42.875H18.375V44.4062H35.2188V42.875ZM16.8438 44.4062H13.7812V45.9375H16.8438V44.4062ZM35.2188 44.4062H18.375V45.9375H35.2188V44.4062ZM16.8438 45.9375H13.7812V47.4688H16.8438V45.9375ZM35.2188 45.9375H18.375V47.4688H35.2188V45.9375ZM16.8438 47.4688H13.7812V49H16.8438V47.4688ZM35.2188 47.4688H18.375V49H35.2188V47.4688Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 36.75H27.5625V38.2812H29.0938V36.75ZM26.0312 38.2812H21.4375V39.8125H26.0312V38.2812Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 38.2812H26.0312V39.8125H27.5625V38.2812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 38.2812H27.5625V39.8125H29.0938V38.2812Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 38.2812H29.0938V39.8125H30.625V38.2812Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 39.8125H19.9062V41.3438H21.4375V39.8125ZM24.5 39.8125H22.9688V41.3438H24.5V39.8125Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 39.8125H24.5V41.3438H26.0312V39.8125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 39.8125H26.0312V41.3438H29.0938V39.8125ZM21.4375 41.3438H19.9062V42.875H21.4375V41.3438ZM24.5 41.3438H22.9688V42.875H24.5V41.3438Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 41.3438H24.5V42.875H27.5625V41.3438Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 41.3438H27.5625V42.875H29.0938V41.3438ZM24.5 42.875H22.9688V44.4062H24.5V42.875ZM29.0938 42.875H27.5625V44.4062H29.0938V42.875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4375 4.59375H19.9062V6.125H21.4375V4.59375ZM27.5625 4.59375H22.9688V6.125H27.5625V4.59375ZM29.0938 6.125H18.375V7.65625H29.0938V6.125ZM29.0938 7.65625H16.8438V9.1875H29.0938V7.65625Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 9.1875H15.3125V10.7188H18.375V9.1875Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 9.1875H18.375V10.7188H29.0938V9.1875Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 9.1875H29.0938V10.7188H33.6875V9.1875ZM22.9688 10.7188H13.7812V12.25H22.9688V10.7188Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 10.7188H22.9688V12.25H29.0938V10.7188Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 10.7188H29.0938V12.25H35.2188V10.7188ZM27.5625 12.25H13.7812V13.7812H27.5625V12.25Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0938 12.25H27.5625V13.7812H29.0938V12.25Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 12.25H29.0938V13.7812H35.2188V12.25ZM36.75 13.7812H12.25V15.3125H36.75V13.7812ZM36.75 15.3125H12.25V16.8438H36.75V15.3125ZM36.75 16.8438H12.25V18.375H36.75V16.8438ZM36.75 18.375H12.25V19.9062H36.75V18.375ZM36.75 19.9062H12.25V21.4375H36.75V19.9062ZM36.75 21.4375H12.25V22.9688H36.75V21.4375ZM36.75 22.9688H12.25V24.5H36.75V22.9688ZM36.75 24.5H12.25V26.0312H36.75V24.5ZM24.5 26.0312H12.25V27.5625H24.5V26.0312Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 26.0312H24.5V27.5625H30.625V26.0312Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 26.0312H30.625V27.5625H36.75V26.0312ZM24.5 27.5625H12.25V29.0938H24.5V27.5625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 27.5625H24.5V29.0938H33.6875V27.5625Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 27.5625H33.6875V29.0938H36.75V27.5625ZM24.5 29.0938H12.25V30.625H24.5V29.0938Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 29.0938H24.5V30.625H30.625V29.0938Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 29.0938H30.625V30.625H36.75V29.0938ZM24.5 30.625H12.25V32.1562H24.5V30.625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 30.625H24.5V32.1562H30.625V30.625Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 30.625H30.625V32.1562H36.75V30.625Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.8438H15.3125V18.375H24.5V16.8438ZM35.2188 16.8438H26.0312V18.375H35.2188V16.8438ZM16.8438 18.375H15.3125V19.9062H16.8438V18.375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 18.375H16.8438V19.9062H19.9062V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.375H19.9062V19.9062H22.9688V18.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.375H22.9688V19.9062H24.5V18.375ZM27.5625 18.375H26.0312V19.9062H27.5625V18.375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 18.375H27.5625V19.9062H30.625V18.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 18.375H30.625V19.9062H33.6875V18.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 18.375H33.6875V19.9062H35.2188V18.375ZM16.8438 19.9062H10.7188V21.4375H16.8438V19.9062Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 19.9062H16.8438V21.4375H19.9062V19.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 19.9062H19.9062V21.4375H22.9688V19.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 19.9062H22.9688V21.4375H27.5625V19.9062Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 19.9062H27.5625V21.4375H30.625V19.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 19.9062H30.625V21.4375H33.6875V19.9062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 19.9062H33.6875V21.4375H35.2188V19.9062ZM12.25 21.4375H10.7188V22.9688H12.25V21.4375ZM16.8438 21.4375H15.3125V22.9688H16.8438V21.4375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 21.4375H16.8438V22.9688H19.9062V21.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 21.4375H19.9062V22.9688H22.9688V21.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.4375H22.9688V22.9688H24.5V21.4375ZM27.5625 21.4375H26.0312V22.9688H27.5625V21.4375Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 21.4375H27.5625V22.9688H30.625V21.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 21.4375H30.625V22.9688H33.6875V21.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 21.4375H33.6875V22.9688H35.2188V21.4375ZM12.25 22.9688H10.7188V24.5H12.25V22.9688ZM16.8438 22.9688H15.3125V24.5H16.8438V22.9688Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 22.9688H16.8438V24.5H19.9062V22.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 22.9688H19.9062V24.5H22.9688V22.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.9688H22.9688V24.5H24.5V22.9688ZM27.5625 22.9688H26.0312V24.5H27.5625V22.9688Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 22.9688H27.5625V24.5H30.625V22.9688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 22.9688H30.625V24.5H33.6875V22.9688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 22.9688H33.6875V24.5H35.2188V22.9688ZM24.5 24.5H15.3125V26.0312H24.5V24.5ZM35.2188 24.5H26.0312V26.0312H35.2188V24.5Z",
    fill: "#F3322C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_8230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhook1);
export default __webpack_public_path__ + "static/media/webhook1.d7578289d35bad6f78a412f4af0fa910.svg";
export { ForwardRef as ReactComponent };